import { useQuery } from '@tanstack/react-query';
import React from 'react';

import { ObjectCard } from '@column/column-ui-kit';

import { ROUTE } from '~/app/routes';
import { useNavigate } from '~/lib/navigation';
import { CardProgram, CardProgramRepository } from '~/repositories/CardProgramRepository';
import { useSessionStore } from '~/stores/Session';

interface CardProgramCardProps {
  cardProgramId: string;
}

const getCardProgramName = (cardProgram?: CardProgram) => {
  if (!cardProgram) return undefined;
  return cardProgram.description || cardProgram.id;
};

export const CardProgramCard: React.FC<CardProgramCardProps> = ({ cardProgramId }) => {
  const navigate = useNavigate();
  const { currentPlatform } = useSessionStore();

  const {
    data: cardProgram,
    isLoading,
    error,
  } = useQuery<CardProgram>({
    queryKey: [currentPlatform?.id, 'card-program', cardProgramId],
    queryFn: async () => CardProgramRepository.get(cardProgramId),
    enabled: !!cardProgramId,
    gcTime: 30000,
    staleTime: 10000,
  });

  const handleNavigate = () => {
    navigate(`${ROUTE.CARD_PROGRAMS}/edit/${cardProgramId}`);
  };

  return (
    <ObjectCard
      error={error ? 'Failed to load card program' : undefined}
      isLoading={isLoading}
      primaryText={getCardProgramName(cardProgram) || 'Card Program'}
      id={{ label: 'ID:', value: cardProgramId }}
      onClick={handleNavigate}
    />
  );
};
